import {ModelType} from "../enums/modelType";
import {Route} from "../enums/route";

export enum commonActions {
  Create = "CREATE",
  Edit = "EDIT",
  Update = "UPDATE",
  Delete = "DELETE",
  Copy = "COPY",
  Publish = "PUBLISH"
}

type actionRoute = {
  [actionName in Partial<commonActions>]: string;
};
//Route Map organized by model type and common actions
export const RouteMap: { [routeKey in Partial<ModelType>]?: { [key in Partial<commonActions>]?: Route } } = {

  [ModelType.ObjectModel]: {
    [commonActions.Create]: Route.objectModel,
    [commonActions.Update]: Route.objectModel,
    [commonActions.Delete]: Route.objectModel,
    [commonActions.Edit]: Route.editObjectModel,
    [commonActions.Publish]: Route.publishObjectModel,
  },
  [ModelType.ContentListView]: {
    [commonActions.Create]: Route.listView,
    [commonActions.Update]: Route.listView,
    [commonActions.Delete]: Route.listView,
    [commonActions.Edit]: Route.editListView,
    [commonActions.Publish]: Route.publishListView,
  },
  [ModelType.ContentDetailView]:{
    [commonActions.Create]: Route.detailView,
    [commonActions.Update]: Route.detailView,
    [commonActions.Delete]: Route.detailView,
    [commonActions.Edit]: Route.editDetailView,
    [commonActions.Publish]: Route.publishDetailView,
  },
  [ModelType.Form]: {
    [commonActions.Edit]: Route.editForm,
  },
  [ModelType.License]: {
    [commonActions.Edit]: Route.editLicense,
  },
  [ModelType.Certificate]: {
    [commonActions.Edit]: Route.editCertificate,
  },
  [ModelType.Mapping]:{
    [commonActions.Edit]: Route.editMapping,
    [commonActions.Publish]: Route.publishMapping,
  },
  [ModelType.ProcessFlow]: {
    [commonActions.Edit]: Route.editProcessFlow,
  },
  [ModelType.PublicProfile]: {
    [commonActions.Edit]: Route.editPublicProfile,
  },
};
